import { render, staticRenderFns } from "./MyReview.vue?vue&type=template&id=5e028dfc&scoped=true"
import script from "./MyReview.vue?vue&type=script&lang=js"
export * from "./MyReview.vue?vue&type=script&lang=js"
import style0 from "./MyReview.vue?vue&type=style&index=0&id=5e028dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e028dfc",
  null
  
)

export default component.exports